export function createGameProperties(game, scenario, hexProperties) {
    return {
        game,
        scenario,
        hexProperties,
    };
}
export function createGamePropertiesWithRules(game, scenario, hexProperties, rules) {
    return {
        game,
        scenario,
        hexProperties,
        rules,
    };
}
